import { ServiceGroup } from '@quorum/models/xs-resource';
import { ServiceGroupQueryParameters } from '@quorum/models/xs-query';
import { Action } from '@ngrx/store';

export enum ServiceGroupsEntityActionTypes {
  GetServiceGroupsFromServer = '[Fixed Operations] Get Service Groups From Server',
  GetServiceGroupsFromServerError = '[Fixed Operations] Get Service Groups From Server Error',
  GetServiceGroupsFromServerSuccess = '[Fixed Operations] Get Service Groups From Server Success'
}

//#region message-types
export class GetServiceGroupsFromServer implements Action {
  readonly type = ServiceGroupsEntityActionTypes.GetServiceGroupsFromServer;
  constructor(public payload: ServiceGroupQueryParameters) {}
}

export class GetServiceGroupsFromServerError implements Action {
  readonly type = ServiceGroupsEntityActionTypes.GetServiceGroupsFromServerError;
  constructor(public payload: any) {}
}

export class GetServiceGroupsFromServerSuccess implements Action {
  readonly type = ServiceGroupsEntityActionTypes.GetServiceGroupsFromServerSuccess;
  constructor(public payload: ServiceGroup[]) {}
}
//#endregion

export type ServiceGroupsEntityAction =
  | GetServiceGroupsFromServer
  | GetServiceGroupsFromServerError
  | GetServiceGroupsFromServerSuccess;

export const fromServiceGroupEntityActions = {
  GetServiceGroupsFromServer,
  GetServiceGroupsFromServerError,
  GetServiceGroupsFromServerSuccess
};
